import { LOGIN, GETJOBS, GETPICKERS } from "../utility/constants";
export function loginAction(bool) {
  return {
    type: LOGIN,
    payload: bool,
  };
}
export function getStoreAction(payload) {
  return {
    type: "GET_STORE_ACTION",
    payload,
  };
}
export function pendingAmountAction(payload) {
  return {
    type: "GET_PENDING_AMOUNT_ACTION",
    payload,
  };
}
export function completedViewDetails(payload) {
  return {
    type: "COMPLETED_VIEW_DETAILS",
    payload,
  };
}
export function updateStatusAction(payload) {
  return {
    type: "GET_UPDATE_STATUS_ACTION",
    payload,
  };
}
export function assignedJobsAction(payload) {
  return {
    type: GETJOBS,
    payload,
  };
}
export function intransitStatusAction(message) {
  return {
    type: "PICKED_STATUS",
    payload: message,
  };
}
export function completedJobsAction(message) {
  return {
    type: "COMPLETED_JOBS",
    payload: message,
  };
}
export function totalItems(items) {
  return {
    type: "TOTAL_ITEMS",
    payload: items,
  };
}
export function actionProcessingJobs(payload) {
  return {
    type: "PROCESSING_JOBS",
    payload,
  };
}
export function actionIntransitJob(payload) {
  return {
    type: "INTRANSIT_JOBS",
    payload,
  };
}
export function actionOrderDetails(payload) {
  return {
    type: "ORDER_DETAILS",
    payload,
  };
}
export function delayReasonAction(payload) {
  return {
    type: "DELAY_REASONS",
    payload,
  };
}
export function delayOrderAction(payload) {
  return {
    type: "DELAY_ORDER",
    payload,
  };
}
export function holdReasonAction(payload) {
  return {
    type: "HOLD_REASONS",
    payload,
  };
}
export function cancelReasonAction(payload) {
  return {
    type: "CANCEL_REASONS",
    payload,
  };
}
export function rescheduleReasonAction(payload) {
  return {
    type: "RESCHEDULE_REASONS",
    payload,
  };
}
export function notifyReasonAction(payload) {
  return {
    type: "NOTIFY_REASONS",
    payload,
  };
}
export function actionDeliverySuccessDetails(payload) {
  return {
    type: "DELIVERY_DETAILS",
    payload,
  };
}

export function actionGetReturnReasons(payload) {
  return {
    type: "RETURN_REASONS",
    payload,
  };
}



// WEBPACK FOOTER //
// ./src/actions/index.js